module.exports = __webpack_public_path__ + "img/webnew53.9d7bb0ec.jpg";